import * as React from "react";

export const SCROLLING_DOWN = 1;
export const SCROLLING_UP = -1;

export function useScrollDirection() {
  const lastScroll = React.useRef(0);
  const [scrollDirection, setScrollDirection] = React.useState();
  React.useEffect(() => {
    window.requestAnimationFrame(() => {
      lastScroll.current = window.pageYOffset;
    });
  }, []);
  const handleScroll = React.useCallback(() => {
    if (Math.abs(lastScroll.current - window.pageYOffset) < 1) return;
    const direction =
      window.pageYOffset > lastScroll.current ? SCROLLING_DOWN : SCROLLING_UP;
    lastScroll.current = window.pageYOffset;
    if (direction !== scrollDirection) {
      setScrollDirection(direction);
    }
  });

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);
  return scrollDirection;
}
